import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetLocalFile = () =>
  useMutation({
    mutationFn: (data) => client(`common/download?path=${data}`),
  });
export const useGetApplicationSettings = () =>
  useMutation({
    mutationFn: () => client(`common/applicationsettings`),
  });
